import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import PageNotFound from "../src/components/404_page_not_found/page_not_found.tsx";
import Login from "../src/components/login/login.tsx";
import Dashboard from "../src/components/dashboard/dashboard.tsx";
import Employee from "../src/components/employee_portal/employee.tsx";
import ClientPanel from "../src/components/client_panel/client_panel.tsx";
import ProtectedRoute from "./components/ProtectedRoute.tsx";
import ClientPanelNotReg from "./components/client_panel_not_reg/client_panel_not_reg.tsx";
import PaymentLink from "./components/payment_link/payment_link.tsx"
import { useEffect } from "react";

function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />{" "}
        {/* Move the logic that uses useNavigate into a child component */}
      </Router>
    </div>
  );
}

function AppContent() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (token && window.location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [token, navigate, window.location.pathname]);

  return (
    <Routes>
      <Route path="*" element={<PageNotFound />} />
      <Route path="/" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/employee-portal"
        element={
          <ProtectedRoute>
            <Employee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client-panel"
        element={
          <ProtectedRoute>
            <ClientPanel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client-panel-not-reg"
        element={
          <ProtectedRoute>
            <ClientPanelNotReg />
          </ProtectedRoute>
        }
      />
       <Route
        path="/generate-payment-link"
        element={
          <ProtectedRoute>
            <PaymentLink />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
